import { LoadingButton } from '@mui/lab'
import { CircularProgress, Typography } from '@mui/material'
import { webApiService } from '@services/index'
import MUIDataTable from 'mui-datatables'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'

const MassEnter = () => {
  const userState = useSelector((state: any) => state.user)
  const [data, setData] = useState<{ loading: boolean, listSupply: any[], hideSingleButton: boolean, html: string }>({ loading: false, listSupply: [], hideSingleButton: false, html: '' })
  const { enqueueSnackbar } = useSnackbar()

  const columns = [
    {
      name: 'id',
      label: 'OT',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'status_name',
      label: 'Estado',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'created_at',
      label: 'Fecha del estado',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any) => {
          return moment(value).format('DD-MM-YYYY')
        }
      }
    },
    {
      name: 'inventory',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        empty: true,
        setCellHeaderProps: () => ({
          style: { textAlign: 'right' }
        }),
        setCellProps: () => ({
          style: { textAlign: 'right' }
        }),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <LoadingButton hidden={data.hideSingleButton} variant='contained' color='warning' className='shadow-none' onClick={() => enterOT(tableMeta.rowData[0])}>Ingresar</LoadingButton>
          )
        }

      }
    }
  ]

  const enterOT = async (idRequest: any) => {
    console.log('idRequest => ', idRequest)
    const item = data.listSupply.find((el: any) => el.id === idRequest)
    console.log('item => ', item)

    if (!item) {
      enqueueSnackbar('OT no encontrada', { variant: 'error' })
      return
    }
    setData({ ...data, loading: true })
    const obj = {
      id_status: item.id_status,
      id_request: item.id,
      id_user: userState.id
    }
    console.log('obj:', obj)

    webApiService.enterOT(obj).then(res => {
      enqueueSnackbar(`OT ${item.id} ingresada a ST`, { variant: 'success' })
      loadData()
    }).catch((error) => {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
      setData({ ...data, loading: false })
    })
  }

  const enterMass = async (seleccionados: any) => {
    console.log('seleccionados => ', seleccionados)
    const indices = seleccionados.data.map((el: any) => el.index)
    console.log('indices => ', indices)
    const list = data.listSupply.filter((_el, idx) => indices.includes(idx))
    console.log('list => ', list)

    setData({ ...data, loading: true, html: '' })
    let html = '----- INICIO -----<br/>'
    for (const item of list) {
      const obj = {
        id_status: item.id_status,
        id_request: item.id,
        id_user: userState.id
      }
      console.log('obj:', obj)
      // eslint-disable-next-line no-loop-func
      await webApiService.enterOT(obj).then((res) => {
        // console.log('🚀 ~ awaitwebApiService.AssignTech ~ res:', res)
        // html += '<p>' + item.id + ' - ' + res.message + '</p>'
        // eslint-disable-next-line no-loop-func
      }).catch((err) => {
        console.log('🚀 ~ awaitwebApiService.sendMails ~ err:', err)
        html += '<p>' + item.id + ' - ' + err.response.data.message + '</p>'
      })
      setData({ ...data, html, loading: true })
    }
    html += '----- FIN -----<br/>'
    loadData(html)
  }

  const loadData : (html?: string) => void = async (html = '') => {
    setData({ ...data, loading: true, html })
    const res = await webApiService.getOtForEnter().then(res => res.data)
    console.log(res)

    setData({ ...data, loading: false, listSupply: res, html })
  }

  useEffect(() => {
    loadData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className='container-xxl '>
        <div className='row gy-3 my-4'>
          <div className='col-12 my-2'>
            <Typography variant='h6' className='title mb-3'>
              INGRESAR A SERVICIO TÉCNICO
            </Typography>

            <div className='shadow-sm rounded bg-white p-3'>
              {
                    data.loading
                      ? (
                        <div className='text-center'><CircularProgress size={20} /> Cargando...</div>
                        )
                      : null
                }
              <div className={data.html === '' ? 'bg-black p-0 text-white mt-2' : 'bg-black p-2 text-white mt-2'} dangerouslySetInnerHTML={{ __html: data.html }} />
              {
                    !data.loading
                      ? (
                        <div className='tabla-ot' data-tour='tabla-ot'>

                          <MUIDataTable
                            title=''
                            data={data.listSupply}
                            columns={columns}
                            options={{
                              selectableRowsHideCheckboxes: false,
                              print: false,
                              download: false,
                              viewColumns: false,
                              textLabels: {
                                selectedRows: { text: 'Filas seleccionadas' }
                              },
                              onRowSelectionChange: (currentRowsSelected: any[], allRowsSelected: any[], rowsSelected?: any[] | undefined) => {
                                console.log('🚀 ~ SuppliesStockPage ~ allRowsSelected:', allRowsSelected)
                                if (allRowsSelected.length > 0) {
                                  setData({ ...data, hideSingleButton: true })
                                } else {
                                  setData({ ...data, hideSingleButton: false })
                                }
                              },
                              customToolbarSelect: selectedRows => {
                                console.log('selectedRows', selectedRows.data.length)
                                return (
                                  <div><LoadingButton variant='contained' color='primary' className='mx-1' onClick={() => enterMass(selectedRows)}>Ingresar ({selectedRows.data.length} OTs)</LoadingButton></div>
                                )
                              }
                            }}
                          />
                        </div>
                        )
                      : null
                }

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MassEnter
